const config = {
    apiUrl: process.env.VUE_APP_API_BASE_URL || 'http://127.0.0.1:8000',
    adminUrl: process.env.VUE_APP_ADMIN_URL  || 'http://127.0.0.1:8000'
}

export {
    config
}
